import React, { useEffect, useRef, useState } from 'react';

import useScrollPosition from '@react-hook/window-scroll';
import ChevronRightIcon from '@repo/ui/components/Icon/ChevronRightIcon';
import { themeStyle } from '@repo/ui/theming';
import { Transition } from 'react-transition-group';

import { ScrollIndicatorElement, ScrollIndicatorWrapper } from './styles';
import { ScrollIndicatorProps } from './types';

const ScrollIndicator: React.FC<ScrollIndicatorProps> = ({
  scrollOnClick,
  hideAfterScroll,
}) => {
  const scrollY = useScrollPosition();
  const [hidden, setHidden] = useState(false);
  const nodeRef = useRef(null);
  useEffect(() => {
    if (hideAfterScroll && scrollY >= window.innerHeight) {
      setHidden(true);
    }
  }, [scrollY, hideAfterScroll]);

  const handleClick = (): void => {
    if (scrollOnClick && !hidden) {
      if (hideAfterScroll) {
        setHidden(true);
      }
      window.scrollTo({
        top: scrollY + window.innerHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Transition
      appear={true}
      in={!hidden}
      nodeRef={nodeRef}
      timeout={{ exit: 600 }}
      unmountOnExit={true}
    >
      {(state): React.ReactElement => (
        <ScrollIndicatorWrapper
          ref={nodeRef}
          isHidden={hidden}
          state={state}
          onClick={handleClick}
        >
          <ScrollIndicatorElement>
            <ChevronRightIcon
              height="12px"
              theme={{
                color: themeStyle.inkMain,
                transform: 'rotate(90deg)',
              }}
            />
          </ScrollIndicatorElement>
        </ScrollIndicatorWrapper>
      )}
    </Transition>
  );
};

export default ScrollIndicator;
